module.exports = __webpack_public_path__ + "media/images/emblems/Hueniken-blason-102180877311486acff0a1793dacdb21.png";